import React from 'react'

import { useUserMetadata } from 'hooks/metadata/useUserMetadata'

export function withHooks(Component: React.ComponentClass) {
    return function WrappedComponent(props: any) {
        const { data } = useUserMetadata()
        return <Component {...props} userMetadata={data} />
    }
}
